var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "green",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M26.7 25.6a5.6 5.6 0 1 0 0-11.2 5.6 5.6 0 0 0 0 11.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "green",
    d: "M28.4 24.6a4.6 4.6 0 1 0 0-9.2 4.6 4.6 0 0 0 0 9.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M9.1 20.3a5.8 5.8 0 1 0 0-11.7 5.8 5.8 0 0 0 0 11.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#802000",
    stroke: "#7b3100",
    strokeWidth: 0.2,
    d: "M8.7 18.8h1.5v-.2s-.4 0-.3-.3c.1-.5.2-.3.3-1.5l.2-3H10v1.4l-.3 1.3-.3 1-.3.6-.3.4-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "green",
    d: "m9.9 10.2-.1.8q-.2.3-.2.8c-.2 0-.3-.3-.5-.1l.5.8.2.4q-.5-.4-.7-.9a2 2 0 0 0-1.3-.8c-.2 0-.9 0-.7.3l.8.5q.5.1.5.4l-.8-.4q-.9-.2-1.4.4v.5q.3-.6.9-.5c.3 0-.4.5-.1.4l.3-.1h.3l.3.2h-.3l-.3.3H7q-.6-.3-.9.2-.1.2-.2 0 .1.4-.4.4l-.5.5c.1.3.6-.3.6 0q-.1.5.2 0t1-.2h.3q.2.1.3-.1 0 .1.2 0l1.1-.2c.4-.2 0 .1 0 .2-.2.3 0 .7-.4.9-.1.4.2.8-.1 1.1q.2.2.5.2c.2 0 0-.5.2-.5q.4 0 .2-.5l.2-1c.2-.4.4.1.2.3q-.3.6 0 1l.2.3.2-.1.3-1.6q.2-.1.4.2l.7.8q.5.3.6.7c0 .2.7.2.5 0q-.2-.4 0-.7.3 0 0 0l.1-.2c.3.1 0-.2-.1-.2q-.4-.2-.6-.6h1q.3 0 .5.3.2 0 0-.3.3 0 .1-.3.1-.2-.1-.3 0-.3-.3-.5c-.3-.1-1 .3-.9-.1l.4-.2c0-.2-.5-.2-.3-.4.1 0 .7-.1.2-.2l-.6-.1c-.1.2-.6-.2-.5.3 0 .2-.4.6-.5.3s.5-.4.4-.7-.2 0-.3 0l.2-.4c.3.2.3-.2.5-.2q.1 0 0-.1c0-.2.3-.2 0-.3q-.4-.1-.6.2-.1-.4.2-.5-.2 0 0 0l.2-.3h-.9l-.3.4zm1.2 3.5v.3s-.4 0-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "m40 27 .4 1.1 1-.4-.6 1 1 .6-1.1.1.1 1.2-.8-.9-.8 1 .1-1.3h-1.2l1-.7-.6-1 1.1.4zm-6.7-10.6.4 1.2 1.1-.5-.6 1 1 .7H34l.2 1.3-.9-1-.8 1 .2-1.2-1.2-.1 1-.7-.7-1 1.2.5zM40 9.2l.4 1.1 1-.4-.6 1 1 .6-1.1.1.1 1.2-.8-.8-.8.8.1-1.2h-1.2l1-.7-.6-1 1.1.4zm6 5.5.3 1 1.1-.3-.6 1 1 .6h-1.2l.2 1.3-.9-.9-.8.9.2-1.2L44 17l1-.6-.7-1 1.2.4zM42.7 20l.3.7h.7l-.6.6.2.7-.6-.4-.7.4.2-.7-.6-.5h.8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.061e2345d2d47d917c0c9d94cc0263eb.svg";
export { ForwardRef as ReactComponent };